/*
 * VULCAN
 */
import { __assign } from "tslib";
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/applicationsMappers";
import * as Parameters from "../models/parameters";
/** Class representing a Applications. */
var Applications = /** @class */ (function () {
    /**
     * Create a Applications.
     * @param {SecurityContext} client Reference to the service client.
     */
    function Applications(client) {
        this.client = client;
    }
    Applications.prototype.getApplications = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, getApplicationsOperationSpec, callback);
    };
    Applications.prototype.createApplication = function (request, options, callback) {
        return this.client.sendOperationRequest({
            request: request,
            options: options
        }, createApplicationOperationSpec, callback);
    };
    Applications.prototype.getApplication = function (id, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            options: options
        }, getApplicationOperationSpec, callback);
    };
    Applications.prototype.updateApplication = function (id, request, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            request: request,
            options: options
        }, updateApplicationOperationSpec, callback);
    };
    Applications.prototype.deleteApplication = function (id, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            options: options
        }, deleteApplicationOperationSpec, callback);
    };
    Applications.prototype.getApplicationPermissions = function (id, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            options: options
        }, getApplicationPermissionsOperationSpec, callback);
    };
    Applications.prototype.replaceApplicationPermissions = function (id, request, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            request: request,
            options: options
        }, replaceApplicationPermissionsOperationSpec, callback);
    };
    Applications.prototype.createApplicationPermissions = function (id, request, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            request: request,
            options: options
        }, createApplicationPermissionsOperationSpec, callback);
    };
    Applications.prototype.deleteApplicationPermissions = function (id, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            options: options
        }, deleteApplicationPermissionsOperationSpec, callback);
    };
    Applications.prototype.getApplicationByName = function (name, options, callback) {
        return this.client.sendOperationRequest({
            name: name,
            options: options
        }, getApplicationByNameOperationSpec, callback);
    };
    return Applications;
}());
export { Applications };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var getApplicationsOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/applications",
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "ApplicationResponse"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var createApplicationOperationSpec = {
    httpMethod: "POST",
    path: "api/v10/applications",
    requestBody: {
        parameterPath: "request",
        mapper: __assign(__assign({}, Mappers.CreateOrUpdateApplicationRequest), { required: true })
    },
    responses: {
        201: {
            bodyMapper: Mappers.ApplicationResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getApplicationOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/applications/{id}",
    urlParameters: [
        Parameters.id
    ],
    responses: {
        200: {
            bodyMapper: Mappers.ApplicationResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var updateApplicationOperationSpec = {
    httpMethod: "PUT",
    path: "api/v10/applications/{id}",
    urlParameters: [
        Parameters.id
    ],
    requestBody: {
        parameterPath: "request",
        mapper: __assign(__assign({}, Mappers.CreateOrUpdateApplicationRequest), { required: true })
    },
    responses: {
        200: {
            bodyMapper: Mappers.ApplicationResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var deleteApplicationOperationSpec = {
    httpMethod: "DELETE",
    path: "api/v10/applications/{id}",
    urlParameters: [
        Parameters.id
    ],
    responses: {
        204: {},
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getApplicationPermissionsOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/applications/{id}/permissions",
    urlParameters: [
        Parameters.id
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "PermissionResponse"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var replaceApplicationPermissionsOperationSpec = {
    httpMethod: "PUT",
    path: "api/v10/applications/{id}/permissions",
    urlParameters: [
        Parameters.id
    ],
    requestBody: {
        parameterPath: "request",
        mapper: __assign(__assign({}, Mappers.ReplaceApplicationPermissionsRequest), { required: true })
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "ApplicationPermissionResponse"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var createApplicationPermissionsOperationSpec = {
    httpMethod: "POST",
    path: "api/v10/applications/{id}/permissions",
    urlParameters: [
        Parameters.id
    ],
    requestBody: {
        parameterPath: "request",
        mapper: __assign(__assign({}, Mappers.CreateApplicationPermissionsRequest), { required: true })
    },
    responses: {
        201: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "ApplicationPermissionResponse"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var deleteApplicationPermissionsOperationSpec = {
    httpMethod: "DELETE",
    path: "api/v10/applications/{id}/permissions",
    urlParameters: [
        Parameters.id
    ],
    responses: {
        204: {},
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getApplicationByNameOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/applications/{name}",
    urlParameters: [
        Parameters.name
    ],
    responses: {
        200: {
            bodyMapper: Mappers.ApplicationResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
//# sourceMappingURL=applications.js.map